import { useParams, Navigate } from 'react-router-dom';
import projectsData from '../data/projects.json';
import { getProjectPage } from '../config/projects.js';
import { usePageTransition } from '../context/TransitionContext.jsx';
import Cards from '../components/Cards.jsx';

const projectsBySlug = Object.fromEntries(projectsData.map(p => [p.slug, p]));

function ProjectTemplate({ project, cards, onBack }) {
  return (
    <section className="page-content">
      {project.imageSrc && (
        <img src={project.imageSrc} alt={project.title} className="project-hero" />
      )}
      <h1><em>{project.title}</em></h1>
      {/* <hr /> */}
      <p>{project.description}</p>
      {cards && cards.length > 0 && <Cards data={cards} />}
      <p style={{ marginTop: '2rem' }}>
        <button className="back-link" onClick={onBack}>
          ← Back to Projects
        </button>
      </p>
    </section>
  );
}

export default function ProjectPage() {
  const { slug } = useParams();
  const { navigateTo } = usePageTransition();
  const project = projectsBySlug[slug];

  if (!project) return <Navigate to="/projects" replace />;

  const config = getProjectPage(slug);
  const CustomComponent = config?.component;

  if (CustomComponent) {
    return <CustomComponent project={project} onBack={() => navigateTo('/projects')} />;
  }

  const enrichedCards = config?.cards?.map(card => ({
    ...card,
    href: card.slug ? `/projects/${slug}/${card.slug}` : (card.href || undefined),
  }));

  return <ProjectTemplate project={project} cards={enrichedCards} onBack={() => navigateTo('/projects')} />;
}
